/**
 * Claves de caché de TanStack Query del panel de Instrumento Financiero (FEAT-105-17).
 *
 * `financial-instrument`: el IF activo del documento (o `null` si no hay). Se
 * invalida tras crear/actualizar/eliminar.
 * `instrument-types`: catálogo de tipos de instrumento (GAP-2), independiente del
 * documento y cacheado con `staleTime` largo (cambia poco).
 */
export const financialInstrumentQueryKey = (documentId: string) =>
  ['financial-instrument', documentId] as const;

export const instrumentTypesQueryKey = () => ['instrument-types'] as const;
